import { Avatar, Box, Typography } from "@mui/material";
import { styles } from "./stylesFollowersModal";
import { useNavigate } from "react-router-dom";

interface UserItemProps {
  username: string;
  avatar?: string | null;
  bio?: string;
  uid: string;
}
const MAX_BIO_LENGTH = 120;
const UserItem: React.FC<UserItemProps> = ({ username, avatar, bio, uid }) => {
  const truncatedBio =
    bio && bio.length > MAX_BIO_LENGTH ? bio.slice(0, MAX_BIO_LENGTH) + "..." : bio;
  const navigate = useNavigate();
  return (
    <Box sx={styles.userItem} onClick={() => navigate(`/profile/${uid}`)}>
      <Avatar src={avatar || undefined} sx={styles.avatar} />

      <Box sx={styles.userInfo}>
        <Typography sx={styles.username}>{username}</Typography>
        {truncatedBio && <Typography sx={styles.userBio}>{truncatedBio}</Typography>}
      </Box>
    </Box>
  );
};

export default UserItem;
